export default __webpack_public_path__ + "static/media/us.767e0eb0.svg";